import { render, staticRenderFns } from "./addCar.vue?vue&type=template&id=a2bd1506&"
import script from "./addCar.vue?vue&type=script&lang=js&"
export * from "./addCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports